import { motion } from 'framer-motion';
import { ArrowRight, Heart } from 'lucide-react';
import { goToApp } from '@/lib/track';

export default function CTASection() {
  const scrollToPricing = () => {
    const el = document.querySelector('#planos');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="cta-section"
      className="py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FAADC7] to-transparent" />

      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[2.5rem] overflow-hidden"
        >
          {/* Background gradient */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #B54182 0%, #BE5791 60%, #B54182 100%)' }} />

          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#FAADC7]/20 to-transparent rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-[#B54182]/30 to-transparent rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" />

          {/* Content */}
          <div className="relative px-8 py-16 md:py-24 md:px-16 text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="inline-flex items-center gap-2 bg-white/15 rounded-full px-5 py-2 mb-8"
            >
              <Heart size={16} className="text-[#FAADC7]" />
              <span className="text-sm font-medium text-[#FAADC7]">Seja uma das primeiras</span>
            </motion.div>

            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 max-w-3xl mx-auto leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Comece sua jornada para uma
              <br />
              <span className="text-[#FAADC7]">menopausa com mais clareza</span>
            </h2>

            <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
              Você merece entender o que está acontecendo com seu corpo. Comece grátis hoje e descubra como o MenoEase pode transformar sua experiência.
            </p>

            <motion.button
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => goToApp('cta-final')}
              className="bg-white text-[#B54182] hover:bg-[#FAADC7]/30 shadow-xl rounded-full px-10 py-5 font-bold text-lg tracking-wide transition-all duration-300 inline-flex items-center gap-3"
              data-testid="final-cta-button"
            >
              Comece Grátis Agora
              <ArrowRight size={20} />
            </motion.button>

            <p className="text-xs text-white/60 mt-6">
              Sem cartão de crédito &middot; Configuração em 1 minuto &middot; Cancele quando quiser
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
